var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"PrintBasketButton-wrapper",class:_vm.componentClasses},[_c('div',{staticClass:"PrintBasketButton",on:{"click":_vm.openPrintBasket}},[_c('span',{staticClass:"icon"}),_c('span',{staticClass:"count",class:{ show: _vm.count > 0 }},[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }